import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';
import { atMinWidth } from '../../../atoms/breakpoints';

const textMappings = {
  Blue: `color: ${color.common.white};`,
  Dark: `color: ${color.common.white};`,
  Red: `color: ${color.common.white};`,
  'Red-Light': `color: ${color.darkBlue[900]};`,
  Grid: `color: ${color.darkBlue[600]};`,
  'Grid-Dark': `color: ${color.darkBlue[100]};`,
};

export const Container = styled.div`
  display: none;
  width: 100%;

  ${atMinWidth.md`
    display: flex;
    flex-direction: column;
    gap: ${spacing[16]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: ${spacing[8]};

  .stars {
    display: flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      color: #efc75e;
      margin-right: 3px;
    }
  }

  .headline {
    ${props => textMappings[props.theme]}
    ${font('text', 'sm', 500)};
  }
`;

export const Logos = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[16]};
`;

export const Logo = styled.img`
  width: fit-content;
  max-width: 140px;
  height: ${props => props?.height || '100%'};
  max-height: 22px;

  @media (min-width: 760px) {
    width: ${props => props?.width || 'fit-content'};
  }
`;
